import { useCallback, useState } from 'react';

export const useDelivery = () => {
  const [customAddressState, setCustomAddressState] = useState<boolean>(false);
  const [dataToEdit, setDataToEdit] = useState<Record<string, any> | undefined>(undefined);

  const onCustomAddressStateChange = useCallback((dataToEdit?: Record<string, any>) => {
    setDataToEdit(dataToEdit);
    setCustomAddressState((oState) => !oState);
  }, []);
  return {
    customAddressState,
    onCustomAddressStateChange,
    dataToEdit,
  };
};
